    <app-header></app-header>
    <div class="master-router-sec">
      <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
